import { fetchWrapper } from '../helpers';

export const focusService = {
  getById,
  create,
  getCatalogForm,
  getCatalogIndustries
};

const baseUrl = `${process.env.BASE_URL}/api/vendor/focus`;
const baseUrlAPI = `${process.env.API_BASE_URL}`;

function getById(id) {
  return fetchWrapper.get(`${baseUrl}?id=${id}`);
}

function create(params) {
  return fetchWrapper.post(baseUrl, params);
}

// API
function getCatalogForm() {
	return fetchWrapper.get(`${baseUrlAPI}/form/focus`);
}

function getCatalogIndustries() {
	return fetchWrapper.get(`${baseUrlAPI}/industries`);
}

